import Vue from "vue"

/**
 * This directive checks if the current user is a superuser and, if it's not,
 * deleteds the component.
 */
Vue.directive("if-superuser", {
  inserted: function (el, binding, vnode) {
    if (!vnode.context.$store.state.auth.profile.is_superuser) {
      el.remove()
    }
  },
})
